"use client";

import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export function V3SectionHouseScroll() {
  const containerRef = useRef<HTMLDivElement>(null);
  
  // Track the scroll progress of the container
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"]
  });

  // Apple-style scaling effect for the background house
  // Starts slightly zoomed in, scales up massively to create a "fly-through" feel
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1, 1.2, 1.4]);
  const opacityImage = useTransform(scrollYProgress, [0, 0.8, 1], [1, 0.5, 0]);

  // Fading logic for text 1
  const opacity1 = useTransform(scrollYProgress, [0, 0.15, 0.3], [0, 1, 0]);
  const y1 = useTransform(scrollYProgress, [0, 0.15, 0.3], [50, 0, -50]);

  // Fading logic for text 2
  const opacity2 = useTransform(scrollYProgress, [0.3, 0.45, 0.6], [0, 1, 0]);
  const y2 = useTransform(scrollYProgress, [0.3, 0.45, 0.6], [50, 0, -50]);

  // Fading logic for text 3
  const opacity3 = useTransform(scrollYProgress, [0.6, 0.8, 1], [0, 1, 0]);
  const y3 = useTransform(scrollYProgress, [0.6, 0.8, 1], [50, 0, -50]);

  return (
    <section ref={containerRef} className="relative h-[300vh] w-full bg-black">
      {/* Sticky Container */}
      <div className="sticky top-0 h-screen w-full overflow-hidden flex items-center justify-center">
        
        {/* Animated Background Image */}
        <motion.div 
          className="absolute inset-0 w-full h-full"
          style={{ scale, opacity: opacityImage }}
        >
          <motion.img 
            src="/images/house-hero.png" 
            alt="Luxury Real Estate" 
            className="object-cover w-full h-full opacity-80"
          />
          {/* Subtle gradient overlay to make text pop */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/80" />
        </motion.div>

        {/* Text Blocks */}
        <div className="relative z-10 w-full max-w-5xl px-6 md:px-12 flex flex-col items-center text-center">
          
          <motion.div style={{ opacity: opacity1, y: y1 }} className="absolute w-full flex flex-col items-center">
            <h2 className="text-4xl md:text-7xl font-bold tracking-tight text-white mb-4">
              Ihre Traumimmobilie.
            </h2>
            <p className="text-lg md:text-2xl text-white/80 max-w-2xl">
              Entdecken Sie atemberaubende Architektur und Design in Perfektion.
            </p>
          </motion.div>

          <motion.div style={{ opacity: opacity2, y: y2 }} className="absolute w-full flex flex-col items-center">
            <h2 className="text-4xl md:text-7xl font-bold tracking-tight text-white mb-4">
              Präzise Analysen.
            </h2>
            <p className="text-lg md:text-2xl text-white/80 max-w-2xl">
              Wir berechnen den wahren Marktwert mit KI-gestützter Präzision.
            </p>
          </motion.div>

          <motion.div style={{ opacity: opacity3, y: y3 }} className="absolute w-full flex flex-col items-center">
            <h2 className="text-4xl md:text-7xl font-bold tracking-tight text-white mb-4">
              Realpilot V3
            </h2>
            <p className="text-lg md:text-2xl text-white/80 max-w-2xl">
              Die Zukunft der Immobilienbewertung beginnt hier.
            </p>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
